var React = require('react');
import ExamContent from './ExamContent';
import AddQuestion from './AddQuestion';
import TableConcept from './TableConcept';
var ViewExam = React.createClass({
    getInitialState: function() {
        return {
        };
    },
    render: function(){
        console.log(this.props)
    	return(
    	<div className="">
            <AddQuestion
                conceptsMap={this.props.conceptsMap}
                currentQuestions={this.props.currentQuestions}
                currentPart={this.props.currentPart}
                setCurrentPart={this.props.setCurrentPart}
                collection={this.props.data}
                course={this.props.courses[this.props.data.course]}
                retrieveQuestionsOfConcept={this.props.retrieveQuestionsOfConcept}
                addQuestionCollection={this.props.addQuestionCollection}
                deleteQuestionCollection={this.props.deleteQuestionCollection}
                sortQuestion={this.props.sortQuestion}
                calculatorDataCollection={this.props.calculatorDataCollection}
            />
            <ExamContent
                collection={this.props.data}
                currentPart={this.props.currentPart}
                courses={this.props.coursesMap}
                conceptsMap={this.props.conceptsMap}
                tableConcept={this.props.tableConcept}
                tableQuestion={this.props.tableQuestion}
                retrieveCollection={this.props.retrieveCollection}
                deleteQuestionCollection={this.props.deleteQuestionCollection}
                calculatorDataCollection={this.props.calculatorDataCollection}
            />
            <TableConcept
                collection={this.props.data}
                courses={this.props.coursesMap}
                conceptsMap={this.props.conceptsMap}
                tableConcept={this.props.tableConcept}
                tableQuestion={this.props.tableQuestion}
            />
    	</div>
    	)
    }
})

export default ViewExam;



/** WEBPACK FOOTER **
 ** ./src/components/ExamEditor/ViewExam.js
 **/